import axios from '../../axios';

//加载头文件
//import * as StkInProductEntryApi from './moudules/stk/StkInProductEntryApi'; //产成品入库单明细
//  StkInProductEntryApi,//产成品入库单明细

// 产成品入库单明细列表
export const getStkInProductEntryPage = data => {
return axios({
url: '/api/sys/stk/getStkInProductEntryPage',
method: 'post',
data
})
};

// 产成品入库单明细保存
export const saveStkInProductEntry = data => {
return axios({
url: '/api/sys/stk/saveStkInProductEntry',
method: 'post',
data
})
};

// 产成品入库单明细修改
export const updateStkInProductEntry = data => {
return axios({
url: '/api/sys/stk/updateStkInProductEntry',
method: 'post',
data
})
};

// 产成品入库单明细删除
export const deleteStkInProductEntrys = data => {
return axios({
url: '/api/sys/stk/deleteStkInProductEntrys',
method: 'post',
data
})
};

// 产成品入库单明细查单条
export const getStkInProductEntry = data => {
return axios({
url: '/api/sys/stk/getStkInProductEntry',
method: 'post',
data
})
};




// WEBPACK FOOTER //
// ./src/api/moudules/stk/StkInProductEntryApi.js